import { Box, SvgIconProps, useTheme } from "@mui/material";

const AddressIcon = ({
  color = "primary",
  height = 18,
  width = 21,
  customColor,
  disableDimentions = false,
  sx = {},
}: SvgIconProps & {
  customColor?: string;
  disableDimentions?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...(!disableDimentions
          ? {
              display: "flex",
              alignItems: "center",
              height: height,
              width: width,
            }
          : {}),
        ...sx,
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9.32539C6 10.121 6.31607 10.8841 6.87868 11.4467C7.44129 12.0093 8.20435 12.3254 9 12.3254C9.79565 12.3254 10.5587 12.0093 11.1213 11.4467C11.6839 10.8841 12 10.121 12 9.32539C12 8.52974 11.6839 7.76668 11.1213 7.20407C10.5587 6.64146 9.79565 6.32539 9 6.32539C8.20435 6.32539 7.44129 6.64146 6.87868 7.20407C6.31607 7.76668 6 8.52974 6 9.32539Z"
          stroke={customColor ?? theme.palette[color]?.dark}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.657 14.9824L10.414 19.2254C10.039 19.6 9.53059 19.8105 9.0005 19.8105C8.47042 19.8105 7.96202 19.6 7.587 19.2254L3.343 14.9824C2.22422 13.8636 1.46234 12.4381 1.15369 10.8863C0.845043 9.33442 1.00349 7.72591 1.60901 6.26412C2.21452 4.80234 3.2399 3.55293 4.55548 2.6739C5.87107 1.79486 7.41777 1.32568 9 1.32568C10.5822 1.32568 12.1289 1.79486 13.4445 2.6739C14.7601 3.55293 15.7855 4.80234 16.391 6.26412C16.9965 7.72591 17.155 9.33442 16.8463 10.8863C16.5377 12.4381 15.7758 13.8636 14.657 14.9824Z"
          stroke={customColor ?? theme.palette[color]?.dark}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
};

export default AddressIcon;
